<ui-dialog [customCloseEvent]="true" (closed)="closeAndEdit()">
  <ng-container dialog-title>Adressangabe prüfen</ng-container>

  <ng-container dialog-content>
    <div class="leading-[1.45] mb-6">
      @if (hasSuggestions) {
        Die eingegebene Adresse konnte nicht eindeutig identifiziert werden. Das kann zum Beispiel
        daran liegen, dass die Schreibweise abweicht. Bitte wähle eine der vorgeschlagenen Adressen
        aus.
      } @else {
        Die eingegebene Adresse konnte nicht eindeutig identifiziert werden. Bitte prüfe die Adresse
        und korrigiere bzw. vervollständige sie.
      }
      <br />
      Fährst Du dennoch mit der eingegebenen Adresse fort, kann das zu einem stark eingeschränkten
      Berechnungsergebnis führen.
    </div>

    <div class="p-4 rounded-lg bg-cp-gray-100 mb-6">
      <strong>Eingegebene Adresse:</strong> {{ formattedEnteredAddress }}
    </div>

    @if (hasSuggestions) {
      <div class="grid gap-3">
        @for (suggestion of formattedSuggestions; track $index) {
          <button
            type="button"
            class="w-full text-left p-4 rounded-lg border border-gray-300 bg-white cursor-pointer"
            [ngClass]="
              selectedIndex() === $index
                ? 'border-cp-secondary-100 ring-1 ring-inset ring-cp-secondary-100'
                : ''
            "
            (click)="selectSuggestion($index)"
          >
            {{ suggestion }}
          </button>
        }
      </div>
    }
  </ng-container>

  <ng-container dialog-actions>
    <button mat-flat-button class="btn-error-lg" (click)="continueWithEnteredAddress()">
      Fortfahren
    </button>
    @if (hasSuggestions) {
      <button mat-flat-button color="accent" class="btn-primary-lg" (click)="applySuggestion()">
        Vorschlag übernehmen
      </button>
    } @else {
      <button mat-flat-button color="accent" class="btn-primary-lg" (click)="closeAndEdit()">
        Adresse bearbeiten
      </button>
    }
  </ng-container>
</ui-dialog>
